export default __webpack_public_path__ + "static/media/ar.39d22654.jpg";